import { useState } from 'react';

export default function Cases() {
  const landmines = [
    {
      title: '財務報表與申報不符',
      description: '銀行會比對 401 / 403 報表,若帳差異過大且無法解釋,容易被質疑誠信。',
      solution: '提前進行財務重整,確保營運數據相符。'
    },
    {
      title: '聯徵次數過多(多查)',
      description: '3 個月內聯徵超過 3 次,會被視為急需資金或被多家銀行退件,大幅降低核貸率。',
      solution: '諮詢顧問精準鎖定最適合的 1–2 家銀行。'
    },
    {
      title: '負責人信用瑕疵',
      description: '信用卡遲繳、強停或親屬代償紀錄,都是銀行核貸的關鍵扣分項。',
      solution: '申請前先調閱聯徵,釐清狀況並優化。'
    },
    {
      title: '資金用途說明不清',
      description: '籠統填寫「週轉金」,而無具體計畫(如採購、擴廠、研發),銀行難以評估還款來源。',
      solution: '提供具體的營運計畫書、訂單或報價佐證。'
    },
    {
      title: '忽視公司設立登記細節',
      description: '資本額未到位、登記地址異常或股權結構複雜,都可能在資格審查階段就被剔除。',
      solution: '檢視公司登記事項,確保符合銀行基本門檻。'
    }
  ];

  return (
    <section id="cases" className="py-24 bg-gradient-to-b from-red-50/30 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
            <i className="ri-error-warning-line text-3xl text-red-600"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">專案申請常見拒貸地雷</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-red-500 to-red-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            魔鬼藏在細節裡,送件前請務必檢查是否踩到了這些銀行審核的紅線。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {landmines.map((landmine, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg border-2 border-red-100 hover:border-red-300 hover:shadow-xl transition-all"
            >
              <div className="flex items-start mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-alert-line text-2xl text-red-600"></i>
                </div>
                <div className="ml-4 flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {landmine.title}
                  </h3>
                </div>
              </div>

              <p className="text-gray-600 leading-relaxed mb-6">
                {landmine.description}
              </p>

              <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4">
                <div className="flex items-start">
                  <i className="ri-lightbulb-line text-green-600 text-xl mr-2 flex-shrink-0 mt-0.5"></i>
                  <div>
                    <h4 className="font-bold text-green-900 text-sm mb-1">解決方案:</h4>
                    <p className="text-green-800 text-sm leading-relaxed">
                      {landmine.solution}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-3xl p-12 text-center border-2 border-red-100">
          <div className="max-w-3xl mx-auto">
            
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              擔心自己不小心踩雷?
            </h3>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              別讓一個小失誤毀了您的資金計畫,讓專業顧問為您進行免費的申請前健檢。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#contact"
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-red-600 to-red-700 text-white text-lg font-bold rounded-xl hover:from-red-700 hover:to-red-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-stethoscope-line mr-2 text-xl"></i>
                預約免費申請健檢
              </a>
              
              <a
                href="https://line.me/R/ti/p/@678gwbht"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-4 bg-white text-red-600 text-lg font-bold rounded-xl border-2 border-red-600 hover:bg-red-600 hover:text-white transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-line-fill mr-2 text-xl"></i>
                LINE 快速諮詢
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
